import { render } from "./MenuHamburger.vue?vue&type=template&id=27864df4"
import script from "./MenuHamburger.vue?vue&type=script&lang=js"
export * from "./MenuHamburger.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__